import React from "react";
import {Button} from "react-bootstrap";
import ReactTable from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import COLOURS from "../resources/colors.js"
import "./AccountTable.css"

const strings = require('../resources/strings.json');

export default function AccountTable(props) {

    const columns = [
        {
            Header: "Email",
            width: 200,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.email} </div>
	    },
        {
            Header: "Subscription",
            width: 100,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.status} </div>
	    },
        {
            Header: "Premises Name",
            width: 150,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.name} </div>
	    },
        {
            Header: "Device Count",
            width: 80,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.deviceCount} </div>
	    },
        {
            Header:  strings.security,
            width: 100,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.security} </div>
        },
        {
            Header:  strings.graphs,
            width: 100,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.graphs} </div>
        },
        {
            Header:  strings.advanceGrouping,
            width: 100,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.advanceGrouping} </div>
        },
        {
            Header: strings.humidity,
            width: 100,
            Cell: (row) => <div  className="textCenterAlignAndMargin"> {row.original.humidity} </div>
        },
        {
            Header: strings.subscriptionEndDate,
            width: 100,
            Cell: (row) => <div className="textCenterAlignAndMargin"> {row.original.subscriptionEndDate} </div>
        },
        {
            Header: "Action",
            width: 100,
            Cell: (row) => (row.original.id) ? <div className="textCenterAlign"> 
            <Button  size="sm" variant="info" onClick={() => props.selectPremises(row.original)}>
                <FontAwesomeIcon icon={faEdit}/>
            </Button> </div> 
            : null
        }
    ];

    const rowFn = (state, rowInfo, column, instance) => {
        if(rowInfo != undefined) {
            return {
                style: {
                    background: subscriptionTimeDiff(rowInfo.original.daysForSubscriptionToEnd)
                }
            };
        }
        return {};
    };

    //Change row color in case subscription has ended or is about to end
    const subscriptionTimeDiff = (diffInDays) => {
        if(diffInDays === null) {
            return null;
        }

        if(diffInDays <= 0) {
            return COLOURS.lightRed
        } else if(diffInDays > 0 && diffInDays < 15 ) {
            return COLOURS.lightYellow
        } else {
            return null
        }
    }



    return (
        <ReactTable
            columns={columns}
            data={props.accountList}
            defaultPageSize={50}
            getTrProps={rowFn}
        />
    )
}
